import { lookupTeamStatus } from 'constant/lookups';

export const groupByProduct = (variants) => {
  return variants.reduce((acc, curr) => {
    const productId = acc.findIndex((item) => item.name === curr.product_name);
    if (productId === -1) {
      acc.push({ name: curr.product_name, variants: [curr.name] });
    } else {
      acc[productId].variants.push(curr.name);
    }
    return acc;
  }, []);
};

export const getProductFromVariant = (products, variantId) => {
  let productId;
  products.forEach((product) => {
    const variant = product.variants.find((item) => item.id === variantId);
    if (variant && !productId) {
      productId = product.id;
    }
  });
  return productId;
};

/**
 * Returns a human-friendly display of the status, given a comma-separated list of status codes.
 * @param status - a comma-separated list of status codes
 * @returns a human-friendly display of the status
 */
export function displayStatus(status: string): string {
  if (!status) {
    return '';
  }
  const statusCodes = status.split(',').map((code) => lookupTeamStatus[code]);
  return statusCodes.join(', ');
}